/**
 * Formats a number with fixed decimal places, replacing dot with comma for French locale
 * @param number - Number to format
 * @param fixed - Number of fixed decimal places
 * @param lang - Language code (converts dot to comma for 'fr')
 * @returns Formatted number string
 */
export const replaceDotByComma = (
  number: number | string,
  fixed: number,
  lang?: string
): string => {
  if (typeof number !== 'number') number = +number
  if (lang?.toLowerCase() === 'fr') {
    return number.toFixed(fixed).replace('.', ',')
  }
  return number.toFixed(fixed)
}
